export const queryKeys = {
  accessToken: 'accessToken',
  locations: 'locations',
  assetTypes: 'assetTypes',
  loadPortal: 'loadPortal',
  assets: 'assets',
  equipmentInfo: 'equipmentInfo',
  equipmentRate: 'equipmentRate',
  portalInfo: 'portalInfo',
  bookingInfo: 'bookingInfo',
  agreement: 'agreement',
  partnerInfo: 'partnerInfo',
  locationHours: 'locationHours',
};
